import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getJsonState} from "modules/selectors";
import {SectionContent, SectionTitle} from "components/Help/common";
import styled from "styled-components";

const Wrapper = styled.div`
	width: 100%;
	color: #ffffff;
`;

export const Terms: React.FC = () => {
	const {t, i18n} = useTranslation();
	const {helpPages} = useSelector(getJsonState);
	const titleLabel = t("help.fifa.terms");

	if (!helpPages || !helpPages.terms) {
		return null;
	}

	const data = helpPages.terms.find((guide) => guide.lang === i18n.language);

	return (
		<Wrapper>
			<SectionTitle>{data?.title ?? titleLabel}</SectionTitle>
			<SectionContent dangerouslySetInnerHTML={{__html: data?.text || ""}} />
		</Wrapper>
	);
};

export default Terms;
